import {
  ArrowDropDown,
  ArrowDropUp,
  DeleteOutline,
  Domain,
  EditOutlined,
  GroupAdd,
  LibraryAdd,
  Add
} from "@mui/icons-material";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  Collapse,
  Checkbox,
  Dialog,
  Tab,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { Field, Form, Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { color } from "../../../../StyleData/Config";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, LocalizationProvider,renderTimeViewClock,DateTimePicker  } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { TabContext, TabList, TabPanel } from "@mui/lab";

import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const WorkPlan = ({ workOrderId }) => {
  const [taskCreate, setCreateTask] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [taskTypeList, setTaskTypeList] = useState([]);
  const [open, setOpen] = useState(false);
  const [editValue, setEditValue] = useState({});
  const [edit, setEdit] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [labour, setLabour] = useState(false);
  const [part, setPart] = useState(false);
  const [value, setValue] = useState("1");
  const [labourList, setLabourList] = useState([]);
  const [checkedDetail, setCheckedDetail] = useState([]);
  const [partList, setPartList] = useState([]);
  const [comDetail, setComDetail] = useState({});
  const [loading,setLoading]=useState(false)
  const [partEditData,setPartEditData]=useState({})
  const [partEdit,setPartEdit]=useState(false)
  const [checkBol,setCheckBol]=useState(false)
  const [source,setSource]=useState("eam")
  const [taskTypeSelect,setTaskTypeSelect]=useState("")
  const [meter,setMeter]=useState([])
  const [multipleChoice,setMultipleChoice]=useState([])
  const siteInfoDetail=useSelector(state=>state.auth.loginInfo)
  

  useEffect(() => {
    console.log(workOrderId, "cehcj");
  
    getTaskList();
   

   
  }, []);

  const getTaskList = async() => {
    setLoading(true)
   
     
    const completeDetail = masterAPI["workOrderTask"].getByWorkOrderId;

   await axiosPrivate
      .get(`${completeDetail}/${workOrderId}`)
      .then(async(res) => {
        console.log(res,"check");
        const sortTaskList = res.data.result;
          sortTaskList.sort((a, b) => a.taskNo - b.taskNo);
        setTaskData(sortTaskList);
    
       
        setLoading(false)
      })
      .catch((e) => {
        setTaskData([])
        console.log(e, "work complete details error");
      });

      

  };

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const handleAddTask = () => {
//     setEdit(false);
//     setMultipleChoice([])
//     setCreateTask(true);
//     setEditValue({});
//     setTaskTypeSelect("")
//   };

//   const onSubmit =async(values, { resetForm }) => {
//     const createLink = masterAPI["workOrderTask"].create;
//     const updateLink = masterAPI["workOrderTask"].update;
//     if (edit) {
//       const putData = {
//         id: editValue.id,
//         listOfChoices:multipleChoice,
//         listOfSelectedChoices:multipleChoice,
//         isMultipleChoice:true,
//         ...values,
//       };
//      await axiosPrivate
//         .put(`${updateLink}`, putData)
//         .then((res) => {
//           console.log(res);
//           getTaskList();
//           resetForm();
//           setEdit(false);
//           setCreateTask(false);
//           setEditValue({});
//           setTaskTypeSelect("")
//           setMultipleChoice([])
//         })
//         .catch((e) => {
//           console.log(e, "update Task");
//         });
//     } else {
//       const postData={
//         ...values,
//         listOfChoices:multipleChoice,
//         listOfSelectedChoices:multipleChoice,
//         isMultipleChoice:multipleChoice.length===0?false:true,

//       }
//       console.log(postData)
//      await axiosPrivate
//         .post(`${createLink}`, postData)
//         .then((res) => {
//           console.log(res);
//           getTaskList();
//           setTaskTypeSelect("")
//           setMultipleChoice([])
//           resetForm();
//         })
//         .catch((e) => {
//           console.log(e, "create Task");
//         });
//     }
//   };
// const confirmDeleteLabour = (id) => {
//   toast(
//     <Grid>
//       <Typography sx={{fontSize:"15px",fontWeight:600, color:"#797979"}}>Are you sure you want to delete?</Typography>
//       <Grid item container spacing={2}>
//         <Grid item>
//           <Button
//             onClick={() => {
//               handleDeleteLabour(id);
//               toast.dismiss();
//             }}
//             sx={{ color: "grey", borderColor: "green" }}
//             size="small"
//             variant="outlined"
//           >
//             Yes
//           </Button>
//         </Grid>
//         <Grid item >
//           <Button
//             onClick={() => toast.dismiss()}
//             sx={{ color: "grey", borderColor: "red" }}
//             size="small"
//             variant="outlined"
//           >
//             No
//           </Button>
//         </Grid>
//       </Grid>
//     </Grid>,
//     {
//       closeButton: false,
//       autoClose: false,
//     }
//   );
// };
// const confirmDeletePart = (id) => {
//   toast(
//     <Grid>
//       <Typography sx={{fontSize:"15px",fontWeight:600, color:"#797979"}}>Are you sure you want to delete?</Typography>
//       <Grid item container spacing={2}>
//         <Grid item>
//           <Button
//             onClick={() => {
//               handlePartDelete(id);
//               toast.dismiss();
//             }}
//             sx={{ color: "grey", borderColor: "green" }}
//             size="small"
//             variant="outlined"
//           >
//             Yes
//           </Button>
//         </Grid>
//         <Grid item >
//           <Button
//             onClick={() => toast.dismiss()}
//             sx={{ color: "grey", borderColor: "red" }}
//             size="small"
//             variant="outlined"
//           >
//             No
//           </Button>
//         </Grid>
//       </Grid>
//     </Grid>,
//     {
//       closeButton: false,
//       autoClose: false,
//     }
//   );
// };
// const confirmDelete = (id) => {
//   toast(
//     <Grid>
//       <Typography sx={{fontSize:"15px",fontWeight:600, color:"#797979"}}>Are you sure you want to delete?</Typography>
//       <Grid item container spacing={2}>
//         <Grid item>
//           <Button
//             onClick={() => {
//               handleDelete(id);
//               toast.dismiss();
//             }}
//             sx={{ color: "grey", borderColor: "green" }}
//             size="small"
//             variant="outlined"
//           >
//             Yes
//           </Button>
//         </Grid>
//         <Grid item >
//           <Button
//             onClick={() => toast.dismiss()}
//             sx={{ color: "grey", borderColor: "red" }}
//             size="small"
//             variant="outlined"
//           >
//             No
//           </Button>
//         </Grid>
//       </Grid>
//     </Grid>,
//     {
//       closeButton: false,
//       autoClose: false,
//     }
//   );
// };
//   const handleDelete=async(id)=>{
//     const wotaskLink=masterAPI["workOrderTask"].delete
//    await axiosPrivate.delete(`${wotaskLink}/${id}`).then(res=>{
//       console.log(res)
//       getTaskList()
//       toast.success("Deleted Successfully")
//     }).catch(e=>{
//       console.log(e,"error task delete")
//     })
//   }

  const listColumns = [
    // {
    //   Header:"checkBox",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Checkbox
    //         checked={checkedList.includes(cell.row.original.id)}
    //         onClick={() => {
    //           handleChecked(cell.row.original);
    //         }}
    //       />
    //     );
    //   },
    // },
    // {
    //         Header: "ID",
    //         accessor: "id",

    //     },
    {
      Header: "Task No",
      accessor: "taskNo",
    },
    {
      Header: "Task Name",
      accessor: "taskName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Sequence No",
      accessor: "sequenceNo",
    },
    {
      Header: "Task Duration (HR)",
      accessor: "taskDuration",
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     // console.log(cell)
    //     return (
    //       <Box sx={{ whiteSpace: "nowrap" }}>
    //         <IconButton>
    //           <EditOutlined
    //             onClick={() => {
               
    //               handleEdit(cell.row.original);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color: color.masterEditDelButtonColor,
    //             }}
    //           />
    //         </IconButton>
    //         <IconButton>
    //                     <DeleteOutline
    //                       onClick={() => {
    //                         confirmDelete(cell.row.original.id);
    //                       }}
    //                       sx={{
    //                         fontSize: color.masterEditDelButton,
    //                         color: color.masterEditDelButtonColor,
    //                       }}
    //                     />
    //                   </IconButton>
    //       </Box>
    //     );
    //   },
    // },
  ];

//   const handleEdit = (value) => {
//     console.log(value);
//     setTaskTypeSelect(value.taskTypeName)
//     setMultipleChoice(value.listOfChoices!==undefined?value.listOfChoices:[""])
//     setEdit(true);
//     setCreateTask(true);
//     setEditValue(value);
//   };

//   const handleChecked = (e) => {
//     setCheckBol(false)
//     if (checkedList.includes(e.id)) {
//       console.log(e, "no");
//       const removeList = checkedList.filter((l) => l !== e.id);
//       setCheckedList(removeList);
//       const removeDetail = checkedDetail.filter((l) => l.id !== e.id);
//       setCheckedDetail(removeDetail);
//     } else {
//       console.log("yes");
//       setCheckedList([...checkedList, e.id]);
//       setCheckedDetail([...checkedDetail, e]);
//     }
//   };

//   const handleCheckAll=(e)=>{
//     if(e.target.checked){
//       setCheckBol(true)
//       const gettaskId=[]
//       for(let i=0;taskData.length>i;i++){
//         console.log(taskData[i])
//         gettaskId.push(taskData[i].id)
//       }
//       setCheckedDetail(taskData)
//       setCheckedList(gettaskId)

//     }else{
//       setCheckBol(false)
//       setCheckedList([])
//       setCheckedDetail([])
//     }
 
//    }

//   const initialValue = {
//     taskName: edit ? editValue.taskName : "",
//     taskNo: edit ? editValue.taskNo : "",
//     sequenceNo: edit ? editValue.sequenceNo : "",
//     description: edit ? editValue.description : "",
//     taskDuration: edit ? editValue.taskDuration : "",
//     taskTypeId: edit ? editValue.taskTypeId : "",
  
//     actualStartDate: edit ? editValue.actualStartDate : null,
//     actualEndDate: edit ? editValue.actualEndDate : null,
//     targetStartDate: edit ? editValue.targetStartDate : comDetail.targetStartDate,
//     targetEndDate: edit ? editValue.targetEndDate : comDetail.targetEndDate,
//     plannedStartDate: edit ? editValue.plannedStartDate : null,
//     plannedEndDate: edit ? editValue.plannedEndDate : null,
//     workOrderId: workOrderId,
//     meterId:edit ? editValue.meterId:null
//   };

//   const handleLabourClose = () => {
//     setLabour(false);
//     setCheckedDetail([])
//     setCheckedList([])
//     getTaskList()
//   };

//   const handlePartClose = () => {
//     setPart(false);
//     setCheckedDetail([])
//     setCheckedList([])
//     getTaskList()
//   };

//   const handlePartEditClose = () => {
//     setPartEdit(false);
//     setPartEditData({})
//     getTaskList()
//   };

//   const handlePartDelete=async(id)=>{
//   const partDelLink=masterAPI["workOrderTaskPart"].delete
//  await axiosPrivate.delete(`${partDelLink}/${id}`).then(res=>{
//     console.log(res)
//     getTaskList()
//   }).catch(e=>{
//     console.log(e,"delete part error")
//   })
//   }
//   const handlePartEdit=(value)=>{
//   setPartEdit(true)
//   setPartEditData(value)
 
//   }
//   const labourSortingData = labourList.sort((a, b) => a.taskNo - b.taskNo);
//   const labourListColumn = [
//     {
//       Header: "Task No",
//       accessor: "taskNo",
//     },
//     {
//       Header: "Craft",
//       accessor: "craftName",
//     },
//     {
//       Header: "Labour",
//       accessor: "labourName",
//     },
//     {
//       Header: "Business",
//       accessor: "businessName",
//     },
//     {
//       Header: "Qty",
//       accessor: "quantity",
//     },

//     {
//       Header: "Planned Hours",
//       accessor: "plannedHours",
//     },
//     {
//       Header: "Rate",
//       accessor: "rate",
//       Cell: ({cell}) => (
//         <>
//         {siteInfoDetail.currencySymbol}{cell.value}
//         </>
//       )
//     },
//     {
//       Header: "Line Cost",
//       accessor:"cost",
//       Cell: ({cell}) => (
//         <>
//         {siteInfoDetail.currencySymbol}{cell.value}
//         </>
//       )
//     },
//    {
//           Header: "Action",
//           accessor: "id",
//           Cell: ({ cell }) => (
//             <IconButton onClick={() => confirmDeleteLabour(cell.value)}>
//               <DeleteOutline sx={{ color: "grey" }} />
//             </IconButton>
//           ),
//         },
//   ];
//   const partSortData = partList.sort((a, b) => a.taskNo - b.taskNo);
//   const partsColumns = [
//     {
//       Header: "Task No",
//       accessor: "taskNo",
//       // Cell: ({ cell }) => {
//       //   return (
//       //    <Typography sx={{

//       //             color: "#0d6efd",
//       //             fontSize:"inherit",
//       //             fontWeight:600

//       //           }}

//       //     >
//       //       {cell.value}
//       //     </Typography>
//       //   );
//       // },
//     },
//     // {
//     //   Header: "Part ID",
//     //   accessor: "partId",
//     // },
//     {
//       Header: "Part Name",
//       accessor: "partName",
//     },
//     {
//       Header: "Issued Qty",
//       accessor: "quantity",
//     },
//     {
//       Header: "Unit",
//       accessor: "unit",
//     },
//     {
//       Header: "Cost",
//       accessor: "cost",
//       Cell: ({cell}) => (
//         <>
//         {siteInfoDetail.currencySymbol}{cell.value}
//         </>
//       )
//     },
//     {
//       Header: "Actions",
//       Cell: ({ cell }) => {
//         // console.log(cell)
//         return (
//           <Box sx={{ whiteSpace: "nowrap" }}>
//             <IconButton>
//               <EditOutlined
//                 onClick={() => {
//                   handlePartEdit(cell.row.original);
//                 }}
//                 sx={{
//                   fontSize: color.masterEditDelButton,
//                   color: color.masterEditDelButtonColor,
//                 }}
//               />
//             </IconButton>
//             {/* <IconButton>
//                         <DeleteOutline
//                           onClick={() => {
//                             handlePartDelete(cell.row.original.id);
//                           }}
//                           sx={{
//                             fontSize: color.masterEditDelButton,
//                             color: color.masterEditDelButtonColor,
//                           }}
//                         /> 
//                       </IconButton> */}
//                       <IconButton onClick={() => confirmDeletePart(cell.row.original.id)}>
//               <DeleteOutline sx={{ color: "grey" }} />
//             </IconButton>
//           </Box>
//         );
//       },
//     },
//   ];

//   const handleRemoveItem = (index) => {
//     const newItems = [...multipleChoice];
//     newItems.splice(index, 1);
//     setMultipleChoice(newItems);
//   };



  return (
    <Grid container >
      
      {loading?<Box sx={{width:"100%",display:"flex",justifyContent:"center"}}><CircularProgress/></Box>:<>
      {/* {taskData.length === 0&&jobPlanId!==undefined ? (
        
        
        <TaskWithId jobPlanId={jobPlanId} workOrderId={workOrderId} getComplete={getTaskList} />
       
      ) : ( */}
        <Grid container gap={"1rem"}>
         
          <Grid
            item
            xs={12}
            sx={{
              boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
              p: 1.5,
              backgroundColor: "white",
            }}
          >
            <Grid container alignItems={"center"} sx={{ mb: "0.5rem" }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: color.masterDialogFontSize,
                  }}
                >
                  {" "}
                  Task List{" "}
                </Typography>
              </Grid>
             
            </Grid>
            <Divider
              sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
            />

            <NormalTable columns={listColumns} data={taskData}  
            // checkBol={checkBol}
             />
            {/* <NormalTableEdit columns={listColumns} data={taskData} handleEditValue={handleEditValue} /> */}
          </Grid>
       
        
        </Grid>
  
      </>}
      
    </Grid>
  );
};

export default WorkPlan;
